import React from "react";
import "./HomePage.css";
import Bluearrow from "../assests/blueArrow.png";

function Organizer({ organizer, setOrganizerDetails, setOrganizerPopup }) {
  const handleClickSponsor = (obj) => {
    setOrganizerDetails(obj);
    setOrganizerPopup(true);
  };
  return (
    <div className="mt-[30px] mb-[32px]">
      <div className="flex items-center justify-between">
        <p className="text-large-medium">Organizer</p>
        {/* <p className="cursor-pointer text-[#0F6ABE] inline-block">
          View All <img className=" inline-block" src={Bluearrow} alt="" />
        </p> */}
      </div>
      {organizer?.map((obj, i) => {
        return (
          <div
            className="flex mt-[12px] items-center justify-start gap-[14px] cursor-pointer"
            key={i}
            onClick={() => handleClickSponsor(obj)}
          >
            <img
              className="rounded-[6px] w-[80px] h-[80px] object-contain "
              src={obj?.logo}
              alt=""
            />
            <div>
              <p className="sponserNae">{obj?.name}</p>
              <p className="mt-[4px] sponserDescription text_3Line">
                {obj?.description}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default Organizer;
